import { tabPanelA11yPropInjector } from "../utils/accessibility"

const TabPanelWrapper = ({ children, value, index, ...other }) => {
    return (
        <div
            hidden={value !== index}
            {...tabPanelA11yPropInjector(index)}
            {...other}
        >
            {value === index && <div>{children}</div>}
        </div>
    );
}

export default TabPanelWrapper